export const CHIP_GAP = 6;
export function fitChipsToWidth(param) {
    let { widths, counterWidth, available } = param;
    if (widths.length === 0) return 0;
    // WHY: before the first layout pass every measurement reads back as zero, and hiding tags on that
    // reading would flash a counter over a column that has room for all of them.
    if (available <= 0) return widths.length;
    const totalWidth = widths.reduce((sum, width)=>sum + width, 0) + CHIP_GAP * (widths.length - 1);
    if (totalWidth <= available) return widths.length;
    let used = 0;
    let fitted = 0;
    for (const width of widths){
        const needed = (fitted > 0 ? CHIP_GAP : 0) + width;
        if (used + needed + CHIP_GAP + counterWidth > available) break;
        used += needed;
        fitted++;
    }
    return Math.max(1, fitted);
}
export const hiddenChipsLabel = (param)=>{
    let { labels, visibleCount } = param;
    return labels.slice(visibleCount).join(', ');
};
